// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { ProductCompareCarouselStyles } from "@turnerBlueprint/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import Close from "@turnerBlueprint/XDL/Icons/Close";
import IconTrash from "@turnerBlueprint/XDL/Icons/IconTrash";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

ProductCompareCarouselStyles.container = {
    css: css`
        min-height: 300px;
    `,
};

ProductCompareCarouselStyles.headerGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 16px;
        margin-bottom: 12px;
        .compare-title {
            display: flex;
            align-items: center;
            gap: 16px;

            ${TypographyStyle} {
                margin: 0;
            }
        }
    `,
};
ProductCompareCarouselStyles.headerRemoveAllButton = {
    ...createLinkIconStyles(IconTrash, {
        icon: {
            position: "left",
        },
    }),
};

ProductCompareCarouselStyles.productsCount = {
    size: 15,
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
        line-height: 17px;
        ${xScreen("lte", "xs")} {
            white-space: nowrap;
        }
    `,
};

ProductCompareCarouselStyles.productCarouselProduct = {
    productGridContainer: {
        container: {
            css: css`
                margin: auto;
            `,
        },
    },
    productActions: {
        productUnitOfMeasureSelectStyles: {
            cssOverrides: {
                formField: css`
                    width: 80px;
                `,
            },
        },
    },
};

ProductCompareCarouselStyles.productRemoveLink = {
    ...createLinkIconStyles(Close, {
        color: "text",
        css: css`
            position: absolute;
            top: 10px;
            right: 10px;
        `,
    }),
};
